import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { deleteData } from "../../hooks/delete";
import Swal from "sweetalert2";
import useSession from "../../hooks/useSession";
import GlobalForm from "../../components/globalForm/GlobalForm";

function ContactPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState([]);
  const [user] = useSession();

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => !item.slug));
  }, [apiData]);

  const { contactSlogan, contactSloganBn, _id } = filteredData[0] ?? {};

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const data = [
    {
      elementType: "heading",
      label: `Update Contact Info`,
      name: "heading",
      type: "heading",
      firstElement: true,
    },
    {
      elementType: "textField",
      label: "Contact details",
      type: "Text",
      name: "contactSlogan",
      defaultValue: contactSlogan,
      fullCol: true,
      required: false,
    },
    {
      elementType: "textField",
      label: "Bangla Contact details",
      type: "Text",
      name: "contactSloganBn",
      defaultValue: contactSloganBn,
      fullCol: true,
      required: false,
    },
  ];

  const update = (data) => {
    delete data.heading;
    console.log(data);
    // const newData = { learnReview: data };
    updateData(homeApi, data, _id);
  };

  return (
    <div className="p-4 lg:p-8">
      {_id && <GlobalForm data={data} update={update} />}
    </div>
  );
}

export default ContactPage;
